import { render, staticRenderFns } from "./BuscaRedeDescredenciada.vue?vue&type=template&id=abb1c2f4&scoped=true"
import script from "./BuscaRedeDescredenciada.vue?vue&type=script&lang=js"
export * from "./BuscaRedeDescredenciada.vue?vue&type=script&lang=js"
import style0 from "./BuscaRedeDescredenciada.vue?vue&type=style&index=0&id=abb1c2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb1c2f4",
  null
  
)

export default component.exports